import "bootstrap";
import 'font-awesome/css/font-awesome.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.css';
import "awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css";
import {I18N, TCustomAttribute, Backend } from 'aurelia-i18n';
// import Backend from 'i18next-xhr-backend';
import { Options } from 'i18next';

// for webpack
// import "./locales/en-CA/translation.json";
// import "./locales/fr-CA/translation.json";

// Exports

export * from "./resources/valueConverters/tickdate-format";
export * from "./resources/valueConverters/date-format";
export * from "./resources/valueConverters/date-string-format";
export * from "./resources/valueConverters/date-string-convert";
export * from "./resources/valueConverters/currency-format";
export * from "./resources/valueConverters/sort";
export * from "./resources/valueConverters/take";
export * from "./resources/valueConverters/number";
export * from "./resources/valueConverters/round";
export * from "./resources/valueConverters/ensure-not-empty";
export * from "./resources/valueConverters/ensure-not-nan";
export * from "./resources/valueConverters/null-if-empty";
export * from "./resources/valueConverters/array-join";
export * from "./resources/valueConverters/cr-br";
export * from "./resources/customAttributes/tooltip/tooltip";
export * from "./resources/customAttributes/blur-on-enter/blur-on-enter";
export * from "./resources/customAttributes/blur-on-escape/blur-on-escape";
export * from "./resources/customAttributes/invoke-on-enter/invoke-on-enter";
export * from "./resources/customAttributes/popover/popover";
export * from "./resources/customAttributes/editable-inline/editable-inline";
export * from "./resources/customElements/editable-inline-input/editable-inline-input";
export * from "./resources/customElements/editable-inline-textarea/editable-inline-textarea";
export * from "./resources/customElements/editable-inline-calendar/editable-inline-calendar";
export * from "./resources/customElements/editable-inline-select/editable-inline-select";
export * from "./resources/customElements/editable-inline-dropdown-checkbox/editable-inline-dropdown-checkbox";
export * from "./resources/customElements/bootstrap-datepicker/datepicker";
export * from "./resources/customElements/dropdown-checkbox/dropdown-checkbox";
export * from "./resources/customElements/bootstrap-number-input/number-input";
export * from "./resources/customElements/sort-column-buttons/sort-column-buttons";
export * from "./resources/customElements/sort-column-header/sort-column-header";
export * from "./resources/customElements/boolean-input/boolean-input";
export * from "./resources/customElements/boolean-button/boolean-button";
export * from "./resources/customElements/form-schema-collection/form-schema-collection";
export * from "./resources/customElements/form-schema-panel/form-schema-panel";
export * from "./resources/customElements/save-cancel-row/save-cancel-row";
export * from "./resources/customBindings/persistent";
export * from "./resources/customBindings/updateTriggerOnKeyPress";


export * from "./interfaces/IDisposable";
export * from "./interfaces/IEventAggregator";
export * from "./interfaces/ISelectOption";

export * from "./services/ajax";
export * from "./services/aurelia-helper-service";
export * from "./services/javascript-service";
export * from "./services/browser-service";
export * from "./services/configuration-service";
export * from "./services/date-service";
export * from "./services/dialog-service";
export * from "./services/disposable-collection";
export * from "./services/dom-service";
export * from "./services/environment-service";
export * from "./services/handle-errors-service";
export * from "./services/logging-service";
export * from "./services/number-service";
export * from "./services/option-service";
export * from "./services/sort-column-service";


export * from "./services/validation/bootstrap-form-renderer";
export * from "./services/validation/validation-event-aggregator";
export * from "./services/validation/validation-service";

export * from "./services/formSchema/form-schema-collection-controller";
export * from "./services/formSchema/form-schema-collection-controller-factory";
export * from "./services/formSchema/form-schema-rules-provider";
export * from "./services/formSchema/form-schema-service";
export * from "./services/formSchema/form-schema-crud-service";

export * from "./services/notification-service/notification-service";

// Configuration

import { PLATFORM } from 'aurelia-pal';
// import { Container } from 'aurelia-dependency-injection';
import { FrameworkConfiguration } from 'aurelia-framework';

// import { Validator, AureliaValidationConfiguration  } from 'aurelia-validation';
// import { AureliaConfiguration  } from 'aurelia-configuration';
// import { Config as NotificationConfiguration  } from 'aurelia-notification';

// export { AureliaConfiguration } from 'aurelia-configuration';
// export { AureliaValidationConfiguration } from'aurelia-validation';
// export { Config as NotificationConfiguration } from 'aurelia-notification';

export interface I18NConfig {
    aliases: Array<string> 
    /**
     * this is the official I18N config passed to I18N.setup
     */
    , i18nOptions: Options
}

export const I18NConfigDefaults: I18NConfig = {
  // only 't' is needed for ferngully
  aliases: ['t', 'i18n'] 
  /**
   * this is the official I18N config passed to I18N.setup
   */
  , i18nOptions: {
        backend: {
          /**
           * For now, the application must tell webpack to load the json files, like this:
           * (but when this is released it won't be necessary:  https://github.com/aurelia/i18n/pull/225)
           * 
           *  { test: /\.json$/i, use: 'raw-loader' }
           * 
           * See this: https://github.com/aurelia/i18n/issues/221
           */
          loadPath: 'ferngully-aurelia-tools/locales/{{lng}}/{{ns}}.json', // <-- XHR settings for where to get the files from
        },
        whitelist: ['en-CA', 'fr-CA',  'en', 'fr'],
        lng:  "en-CA",
        fallbackLng : 'en-CA',
        debug : false
      }
} 


export class FerngullyAureliaToolsConfiguration {
//
// /**
//  * Typically:
//  * config.setDirectory('[folder where your config file is located]');
//  * config.setEnvironment('[something like Development or Production]');
//  */
//   public configurationConfig: (config: AureliaConfiguration) => void;
// /**
//  * Defaults are:
//  * notifications =
//  * {
//  *  "success": "humane-libnotify-success",
//  *  "error": "humane-libnotify-error",
//  *   "info": "humane-libnotify-info"
//  * }
//  */ 
//   public notificationsConfig: (config: NotificationConfiguration) => void;
//   /**
//    * the usual for Aurelia validation, the customValidator
//    */
//   public validationConfig: (config: AureliaValidationConfiguration) => void;

/**
 * use this to apply default Aurelia-I18next configuration, like this:
 * 
 *         .plugin(PLATFORM.moduleName('aurelia-i18n', (instance) => {
 *             return FerngullyAureliaToolsConfiguration.ConfigureI18Next(aurelia, instance)
 *         }))
 * 
 * or to modify the i18next options:
 *         .plugin(PLATFORM.moduleName('aurelia-i18n', (instance) => {
 *             return FerngullyAureliaToolsConfiguration.ConfigureI18Next(
 *                aurelia, 
 *                instance, 
 *                (defaultPluginConfig: I18NConfig) => defaultPluginConfig.i18nOptions.lng = "fr-CA"))
 *         }))
 *
 * @param frameworkConfig 
 * @param instance 
 * @param callback 
 */
  public static ConfigureI18Next(
      frameworkConfig: FrameworkConfiguration,
      instance: I18N,
      callback?: (config: I18NConfig) => void) : Promise<FrameworkConfiguration> 
  {
      const i18nConfig = I18NConfigDefaults;

      if (callback instanceof Function) {
        // user gets a chance to do their thing
        callback(i18nConfig);
      }

      let aliases = i18nConfig.aliases;
      let options = i18nConfig.i18nOptions;

      // add aliases for 't' attribute
      if (aliases && aliases.length)
      {
        TCustomAttribute.configureAliases(aliases);
        (<any>options)["attributes"] = aliases;
      }
      
      // register backend plugin
      instance.i18next.use(Backend.with(frameworkConfig.aurelia.loader));
      // instance.i18next.use(Backend);

      // see http://i18next.com/docs/options/
      // make sure to return the promise of the setup method, in order to guarantee proper loading
      return instance.setup(options).then(() => frameworkConfig);
  }
}


/**
 * Configures the plugin.
 */
export function configure(
                      frameworkConfig: FrameworkConfiguration,
                      callback?: (config: FerngullyAureliaToolsConfiguration) => void)
{
      // configure...
    const thisConfiguration = new FerngullyAureliaToolsConfiguration();

    /** not actually doing anything with this yet */
    if (callback instanceof Function) {
      // user gets a chance to do their thing
      callback(thisConfiguration);
    }

    // frameworkConfig
    //     .plugin("aurelia-event-aggregator")
    //     .plugin("aurelia-dialog")
    //     .plugin('aurelia-validation', 
    //       (config: AureliaValidationConfiguration ) => {
    //         if (thisConfiguration.validationConfig)
    //             {
    //               thisConfiguration.validationConfig(config);
    //             }
    //         })
    //     .plugin("aurelia-configuration",
    //       (config: AureliaConfiguration) => {
    //         if (thisConfiguration.configurationConfig) {
    //           thisConfiguration.configurationConfig(config);
    //         }
    //       })

    //     .plugin("aurelia-notification",
    //       (config: NotificationConfiguration) => {
    //         if (thisConfiguration.notificationsConfig) {
    //           thisConfiguration.notificationsConfig(config);
    //         } else {
    //               config.notifications = {
    //                   "success": "humane-libnotify-success",
    //                   "error": "humane-libnotify-error",
    //                   "info": "humane-libnotify-info"
    //               };
    //         }
    //    })
    //  ;

    // make webpack bundle the translation files
    PLATFORM.moduleName("./locales/en-CA/translation.json");
    PLATFORM.moduleName("./locales/fr-CA/translation.json");

    // globalize the behaviors.
    if (frameworkConfig.globalResources) {

      frameworkConfig.globalResources( [

          PLATFORM.moduleName("./resources/valueConverters/tickdate-format"),
          PLATFORM.moduleName("./resources/valueConverters/date-format"),
          PLATFORM.moduleName("./resources/valueConverters/date-string-format"),
          PLATFORM.moduleName("./resources/valueConverters/date-string-convert"),
          PLATFORM.moduleName("./resources/valueConverters/currency-format"),
          PLATFORM.moduleName("./resources/valueConverters/sort"),
          PLATFORM.moduleName("./resources/valueConverters/take"),
          PLATFORM.moduleName("./resources/valueConverters/number"),
          PLATFORM.moduleName("./resources/valueConverters/round"),
          PLATFORM.moduleName("./resources/valueConverters/ensure-not-empty"),
          PLATFORM.moduleName("./resources/valueConverters/ensure-not-nan"),
          PLATFORM.moduleName("./resources/valueConverters/null-if-empty"),
          PLATFORM.moduleName("./resources/valueConverters/array-join"),
          PLATFORM.moduleName("./resources/valueConverters/cr-br"),
          PLATFORM.moduleName("./resources/customAttributes/tooltip/tooltip"),
          PLATFORM.moduleName("./resources/customAttributes/popover/popover"),
          PLATFORM.moduleName("./resources/customAttributes/blur-on-enter/blur-on-enter"),
          PLATFORM.moduleName("./resources/customAttributes/blur-on-escape/blur-on-escape"),
          PLATFORM.moduleName("./resources/customAttributes/invoke-on-enter/invoke-on-enter"),
          
          PLATFORM.moduleName("./resources/customAttributes/editable-inline/editable-inline"),
          PLATFORM.moduleName("./resources/customElements/editable-inline-calendar/editable-inline-calendar"),
          PLATFORM.moduleName("./resources/customElements/editable-inline-input/editable-inline-input"),
          PLATFORM.moduleName("./resources/customElements/editable-inline-textarea/editable-inline-textarea"),
          PLATFORM.moduleName("./resources/customElements/editable-inline-select/editable-inline-select"),
          PLATFORM.moduleName("./resources/customElements/editable-inline-dropdown-checkbox/editable-inline-dropdown-checkbox"),
          PLATFORM.moduleName("./resources/customElements/bootstrap-datepicker/datepicker"),
          PLATFORM.moduleName("./resources/customElements/dropdown-checkbox/dropdown-checkbox"),
          PLATFORM.moduleName("./resources/customElements/bootstrap-number-input/number-input"),
          PLATFORM.moduleName("./resources/customElements/sort-column-buttons/sort-column-buttons"),
          PLATFORM.moduleName("./resources/customElements/sort-column-header/sort-column-header"),
          PLATFORM.moduleName("./resources/customElements/boolean-input/boolean-input"),
          PLATFORM.moduleName("./resources/customElements/boolean-button/boolean-button"),
          PLATFORM.moduleName("./resources/customElements/form-schema-collection/form-schema-collection"),
          PLATFORM.moduleName("./resources/customElements/form-schema-panel/form-schema-panel"),
          PLATFORM.moduleName("./resources/customElements/save-cancel-row/save-cancel-row"),
          PLATFORM.moduleName("./resources/customBindings/persistent"),
          PLATFORM.moduleName("./resources/customBindings/updateTriggerOnKeyPress")
      ]);
    }
}